module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm3"
    }
  }, [_c('p', {
    staticClass: "headimg"
  }, [_vm._v("ALSO BY KATE GRENVILLE")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOVELS")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lilian’s Story")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dark Places")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreamhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Joan Makes History")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Idea of Perfection")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret River")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lieutenant")])]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SHORT STORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "also",
    staticStyle: {
      "margin-top": ".2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bearded Ladies")])]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NON-FICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Writing Book")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Making Stories ")]), _vm._v("(with Sue Woolfe)")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Writing from Start to Finish")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Searching for the Secret River")])]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_vm._v("Notes for readers available at "), _c('a', {
    attrs: {
      "href": "http://kategrenville.com",
      "target": "_blank"
    }
  }, [_vm._v("kategrenville.com")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_vm._v("Teachers’ notes and reading group notes for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sarah Thornhill")]), _vm._v(" available at "), _c('a', {
    attrs: {
      "href": "http://textpublishing.com.au/resources",
      "target": "_blank"
    }
  }, [_vm._v("textpublishing.com.au/resources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a23d9d8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also_by.vue
// module id = 69
// module chunks = 0